<!-- Part of the SPARKL educational activity system, Copyright 2019 by Pepper Williams -->
<template><div>
	<div v-if="resource!==null">
		<div v-if="show_quick_look_for_reslink">
			<ResourceCollectionItem v-if="resource"
				ref="resource_collection_item" 
				:item="resource" 
				:quick_look_only="true"
				:option_overrides="resource_option_overrides"
			/>
		</div>

		<iframe v-else 
			name='resource_link_view_iframe' 
			:src="resource_url"
		></iframe>

		<div class="k-resource-link-view-new-window-btn-wrapper"
			v-if="new_window_btn_showing"
		>
			<k-btn color="primary" class="k-tight-btn k-nocaps-btn"
				@click="open_in_new_window"
			>Open “{{resource.description}}” in a New Window</k-btn>
			<k-btn icon color="#000" dark class="ml-2"
				@click="new_window_btn_showing=false"
			><k-icon large>fas fa-circle-xmark</k-icon></k-btn>
		</div>
	</div>
</div></template>

<script>
import { mapState, mapGetters } from 'vuex'
import ResourceCollectionItem from '../resources/ResourceCollectionItem'

export default {
	components: { ResourceCollectionItem, },
	props: {
		reslink_resource_id: { type: String, required: true },
	},
	data() { return {
		resource_url: '',
		new_window_btn_showing: false,
		// raw_lti_form: '',
		lti_form: '',
		resource: null,
		resource_option_overrides: {},	// in case we need these someday...
	}},
	computed: {
		show_quick_look_for_reslink() { 
			// if we're in reslink_embed_mode, show the resource directly (not in quick_look mode)
			if (vapp.reslink_embed_mode) return false
			// else look at site_config.show_quick_look_for_reslink
			return this.$store.state.site_config.show_quick_look_for_reslink == 'yes' 
		},
	},
	created() {
		vapp.reslink_component = this
		
		// Canvas provides some handy postMessage commands to optimize the iframe environment; use them
		try {
			console.log('optimizing canvas')
			// remove right-side nav
			window.parent.postMessage({subject: 'lti.hideRightSideWrapper'}, '*')

			// change height of iframe -- let's not do this for now; user can always open in a new window
			// window.parent.postMessage({subject: 'lti.frameResize', height: 1000}, '*')

			// scroll iframe to top of container -- let's not do this for now
			// window.parent.postMessage({subject: 'lti.scrollToTop'}, '*')
		} catch(e) {}
	},
	activated() {
		// if we come back to the reslink path after exiting, we have to re-show the quick_look
		if (this.$refs.resource_collection_item?.show_quick_look) {
			this.$refs.resource_collection_item.show_quick_look()
		}
	},
	mounted() {
		// http://localhost:7088/reslink/RESOURCE_6_SCI_GA19ED_ESE_G03U00L00_001_EN
		// https://henryconnects.henry.k12.ga.us/reslink/b717fb5f-e758-496c-b0a7-5dab757c18fc
		let payload = {
			resource_id: this.reslink_resource_id,
			// resource_id: vapp.reslink_resource_id,
			get_lti_form: 'yes',
		}

		this.$store.dispatch('get_resource_record', payload).then(result=>{
			this.resource = new Resource(result.resource_record)

			// TODO: if it's an LTI link and the user isn't signed in, 
			// or if it's not an agency-sanctioned asset, or something the user *must* have permission to view,
			// make them sign in first

			// if we're *not* showing the quick_look first for reslink paths, we want to jump right to the resource
			// this will usually be because we're in reslink_embed_mode
			// but we will try show the resource in an iframe, showing a btn that allows the user to open in a new window
			if (!this.show_quick_look_for_reslink) {
				this.new_window_btn_showing = true

				// if we got back an lti_form, launch, originally in our iframe
				if (!empty(result.lti_form)) {					
					this.lti_form = result.lti_form

					// we have to load on nextTick so that the iframe will be rendered in the DOM
					this.$nextTick(()=>{
						Resource.open_lti_resource_from_lti_form(this.lti_form, payload.resource_id, 'resource_link_view_iframe')
					})

				} else {
					// use direct_resource_url from the resource object to get the proper url to use
					let url = this.resource.direct_resource_url()

					// but if url is itself a reslink url, use the "raw" url
					if (url.includes('/reslink/')) url = this.resource.url
					
					this.resource_url = url
				}
			}
		})

	},
	methods: {
		open_in_new_window() {
			if (!empty(this.lti_form)) {
				// for LTI 1.1 launches, we need to get the lti_form again, in case it has a nonce that was used when we opened it in the initial iframe
				if (this.lti_form.includes('oauth_nonce')) {
					let payload = {
						resource_id: this.reslink_resource_id,
						get_lti_form: 'yes',
					}
					this.$store.dispatch('get_resource_record', payload).then(result=>{
						console.warn('got new lti form')
						Resource.open_lti_resource_from_lti_form(result.lti_form, this.resource.resource_id, '_blank')
					})
				} else {
					Resource.open_lti_resource_from_lti_form(this.lti_form, this.resource.resource_id, '_blank')
				}

			} else {
				window.open(this.resource_url, '_blank')
			}
		}
	}
}
</script>

<style lang="scss">
[name=resource_link_view_iframe] {
	width:100vw;
	height:100vh;
	border:0;
	background-color:#fff;
}

.k-resource-link-view-new-window-btn-wrapper {
	position:fixed;
	right:0;
	top:0;
	background-color:#fff;
	border-radius:16px;
	padding:12px 16px;
	margin:8px;
}
</style>
